import Vue from 'vue';
import VueRouter from 'vue-router';
import ActivitiesOverview from '@/components/blocks/activities-overview';

Vue.use(VueRouter);

const activityUrl = new XMLHttpRequest();

activityUrl.open('GET', '/api/activity/activityurl');
activityUrl.send();

const routes = [
    { path: activityUrl.response, component: ActivitiesOverview },
    { path: activityUrl.response + '*', component: ActivitiesOverview }
];

export default new VueRouter({
    routes,
    mode: 'history'
});
